export default __webpack_public_path__ + "static/media/RO03.d6eebb16.jpg";